import Base from "@/api/Base";

export default class Save extends Base
{
	setAutoRenew (v)
	{
		this.data.autoRenew = v;
		return this;
	}

	setFollowUpProduct (v)
	{
		this.data.followUpProduct = v;
		return this;
	}

	getMethod ()
	{
		return 'PATCH';
	}

	getUrl ()
	{
		return '/kunde/abo';
	}
}
